var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinterest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.282.782C4.67.782.117 5.332.117 10.942c0 4.16 2.505 7.734 6.086 9.308-.028-.708-.005-1.56.177-2.331l1.307-5.539s-.327-.649-.327-1.606c0-1.506.871-2.63 1.96-2.63.926 0 1.37.694 1.37 1.524 0 .93-.594 2.318-.898 3.606-.254 1.08.54 1.955 1.607 1.955 1.924 0 3.222-2.472 3.222-5.403 0-2.227-1.502-3.892-4.23-3.892-3.081 0-5.005 2.3-5.005 4.868 0 .884.263 1.51.671 1.99.186.223.214.314.146.568-.05.186-.16.635-.21.816-.067.259-.276.35-.507.254-1.42-.58-2.083-2.131-2.083-3.882 0-2.885 2.437-6.346 7.265-6.346 3.88 0 6.435 2.808 6.435 5.82 0 3.986-2.22 6.962-5.487 6.962-1.098 0-2.128-.594-2.482-1.265 0 0-.59 2.34-.717 2.794-.213.784-.635 1.565-1.02 2.177.935.276 1.905.416 2.88.417 5.614 0 10.166-4.55 10.166-10.16 0-5.611-4.547-10.165-10.16-10.165Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.f285ace52cfdb7de9caeb344bebbf20c.svg";
export { ForwardRef as ReactComponent };